<template>
  <div style="position: relative; padding: 0px 0 30px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px;"
    ></v-premium-plan-popup>
    <v-container>
      <v-layout>
        <v-flex>
          <h3 class="headline mt-2">{{ $t('Coupon') }}</h3>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="showAdd = true" :disabled="coupons.length >= 10"
            ><v-icon>add</v-icon>{{ $t('Add Coupon') }}</v-btn
          >
        </v-flex>
      </v-layout>

      <div class="text-xs-center my-4" v-if="coupons.length == 0">
        {{ $t('No coupon') }}
      </div>
      <template v-else>
        <v-layout wrap>
          <template v-for="(coupon, cindex) in coupons">
            <v-flex xs12 sm6 md4 class="mb-2 pa-1" :key="cindex">
              <v-card>
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      <div class="caption grey--text lighten-1">{{ coupon.name }}</div>
                      <div class=" mb-2">
                        Code:
                        <span class="primary--text" style="text-transform: uppercase;">{{
                          coupon.code
                        }}</span>
                      </div>
                    </v-flex>
                    <v-btn
                      small
                      fab
                      flat
                      class="ma-0"
                      v-clipboard:copy="coupon.code"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onCopyError"
                      ><v-icon>content_copy</v-icon></v-btn
                    >
                  </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-text>
                  <div class="caption">{{ $t('Minimum purchase of') }}</div>
                  <div
                    class="display-1"
                    :class="{
                      'cyan--text lighten-2': coupon.promotype == 'price',
                      'orange--text lighten-2': coupon.promotype == 'piece'
                    }"
                  >
                    <template v-if="coupon.promotype == 'price'">
                      {{ coupon.promovalue | numberFormat }} {{ $t('Baht') }}
                    </template>
                    <template v-else
                      >{{ coupon.promovalue | numberFormat }} {{ $t('Items') }}</template
                    >
                  </div>
                  <div class="font-weight-bold">
                    <template v-if="coupon.discounttype == 'price'">
                      {{ $t('Discount price') }} {{ coupon.discountvalue | numberFormat }}
                      {{ $t('Baht') }}
                    </template>
                    <template v-else-if="coupon.discounttype == 'percent'">
                      {{ $t('Discount percent') }} {{ coupon.discountvalue }} %
                    </template>
                    <template v-else-if="coupon.discounttype == 'ship'">
                      {{ $t('Discount shipping fee') }} {{ coupon.discountvalue | numberFormat }}
                      {{ $t('Baht') }}
                    </template>
                    <template v-else-if="coupon.discounttype == 'freeship'">
                      {{ $t('Free Delivery') }}
                    </template>
                  </div>
                </v-card-text>
                <div
                  style="height: 2px"
                  :class="{
                    'cyan lighten-2': coupon.promotype == 'price',
                    'orange lighten-2': coupon.promotype == 'piece'
                  }"
                ></div>
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      <v-btn
                        color="primary"
                        class="ma-1"
                        depressed
                        small
                        @click="editCoupon(coupon)"
                      >
                        {{ $t('edit') }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        class="ma-1"
                        flat
                        small
                        @click="onDeleteCoupon(coupon)"
                      >
                        {{ $t('Delete') }}
                      </v-btn>
                    </v-flex>
                    <v-flex class="text-xs-right">
                      <toggle-button
                        :value="coupon.status"
                        :sync="true"
                        @change="onChangeStatus(coupon, $event)"
                        :color="$vuetify.theme.success"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>
        </v-layout>
      </template>
      <add-coupon v-model="showAdd" :coupons="coupons" @onsave="onAddCoupon"></add-coupon>
      <template v-if="currentCoupon">
        <add-coupon
          :key="timestamp"
          v-model="showEdit"
          :coupons="coupons"
          :currentcoupon="currentCoupon"
          @onsave="onEditCoupon"
        ></add-coupon>
      </template>
    </v-container>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Code Copied') }}!</v-snackbar
    >
  </div>
</template>

<script>
import api from '@/api'
import AddCoupon from './AddCoupon'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      showCopy: false,
      showAdd: false,
      showEdit: false,
      coupons: [],
      currentCoupon: null,
      timestamp: moment().format('x')
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    AddCoupon,
    ToggleButton
  },
  async mounted() {
    if (this.selectedBot.theme == 'ecommercebasic') {
      this.$store.dispatch('loadCategory').then(function() {})
    }
    var response = await this.getpromotioncode()
    this.coupons = response.map(el => {
      try {
        return {
          ...el,
          category: JSON.parse(el.category)
        }
      } catch (error) {
        console.error(error)
        return {
          ...el,
          category: []
        }
      }
    })
  },
  methods: {
    async editCoupon(coupon) {
      this.currentCoupon = coupon
      this.timestamp = moment().format('x')
      await this.$nextTick()
      this.showEdit = true
    },
    savepromotioncode(coupon) {
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        data: coupon
      }

      return new Promise((resolve, reject) => {
        api.savepromotioncode(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve(response.data)
          }
        })
      })
    },
    editpromotioncode(coupon) {
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        data: coupon
      }

      return new Promise((resolve, reject) => {
        api.editpromotioncode(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve(response.data)
          }
        })
      })
    },
    getpromotioncode() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getpromotioncode(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.responsecode == 200) {
            resolve(response.data)
          }
        })
      })
    },

    async onChangeStatus(value, event) {
      this.$store.dispatch('loading')
      try {
        var index = this.coupons.findIndex(el => {
          return el.id == value.id
        })
        this.$set(this.coupons[index], 'status', event.value)
        var response = await this.editpromotioncode(this.coupons[index])

        if (response && response.length > 0) this.$set(this.coupons, index, response[0])
      } catch (error) {}
      this.$store.dispatch('loading')
    },
    onCopy() {
      this.showCopy = true
    },
    onCopyError() {},
    async onEditCoupon(payload) {
      this.$store.dispatch('loading')
      try {
        if (payload.id) {
          var index = this.coupons.findIndex(el => {
            return el.id == payload.id
          })
          payload.category = JSON.stringify(payload.category)
          var response = await this.editpromotioncode(payload)
          if (response && response.length > 0) this.$set(this.coupons, index, response[0])
        }
      } catch (error) {}
      this.currentCoupon = null
      this.$store.dispatch('loading')
    },
    async onAddCoupon(payload) {
      this.$store.dispatch('loading')
      try {
        payload.category = JSON.stringify(payload.category)
        var response = await this.savepromotioncode(payload)

        if (response && response.length > 0) this.coupons.push(response[0])
      } catch (error) {
        console.log(error)
      }
      this.$store.dispatch('loading')
    },
    async onDeleteCoupon(coupon) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var index = this.coupons.findIndex(el => {
          return el.id == coupon.id
        })
        if (index != -1) {
          api.deletepromotioncode(
            { id: coupon.id, pageid: this.selectedBot.pageid },
            (error, response) => {
              if (error) {
                return false
              }
              if (response.responsecode == 200) {
              }
            }
          )
          this.coupons.splice(index, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Promotion.vue